// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestId } from './Harvest';
import { fermentationBrothId } from './FermentationBroth';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestBrothSourceId = (z.number());
export const harvestBrothSource = z.object({
    id: harvestBrothSourceId,
    harvest_id: harvestId,
    broth_collection_id: fermentationBrothId,
    sort_order: z.number(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const harvestBrothSourceInitializer = z.object({
    id: harvestBrothSourceId.optional(),
    harvest_id: harvestId,
    broth_collection_id: fermentationBrothId,
    sort_order: z.number(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const harvestBrothSourceMutator = z.object({
    id: harvestBrothSourceId.optional(),
    harvest_id: harvestId.optional(),
    broth_collection_id: fermentationBrothId.optional(),
    sort_order: z.number().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestBrothSource.js.map